import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.sizeOptions = [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Medium',
      value: 'medium'
    }, {
      label: 'Small',
      value: 'small'
    }, {
      label: 'Mini',
      value: 'mini'
    }];
  }
  get size() {
    return AppModule.size;
  }
  handleSetSize(size) {
    this.$ELEMENT.size = size;
    AppModule.SetSize(size);
    this.refreshView();
    this.$message({
      message: 'Switch Size Success',
      type: 'success'
    });
  }
  refreshView() {
    // In order to make the cached page re-rendered
    TagsViewModule.delAllCachedViews();
    const {
      fullPath
    } = this.$route;
    this.$nextTick(() => {
      this.$router.replace({
        path: '/redirect' + fullPath
      });
    });
  }
};
default_1 = __decorate([Component({
  name: 'SizeSelect'
})], default_1);
export default default_1;